<template>
  <li class="navigator-item" @click="scroll(to)">
    <span class="navigator-item-circle"></span>
    <span class="navigator-item-text"><slot></slot></span>
  </li>
</template>

<script>
import { scrollToElement } from '../../../util/scroll-to-element'

export default {
  name: 'BaseNavigatorItem',
  props: {
    to: { type: String }
  },
  methods: {
    scroll (to) {
      scrollToElement(`#${to}`, 70)
    }
  }
}
</script>

<style scoped>
.navigator-item-circle {
  @apply rounded-full border border-black block my-1 relative cursor-pointer;
  width: 15px; height: 15px;
  transition: all .5s ease-in-out;
}
.navigator-item-circle:hover {
  background: black;
}
.navigator-item:hover > .navigator-item-text{
  @apply block;
}
.navigator-item-text {
  @apply hidden absolute bg-black text-white mr-1 px-2 py-1 rounded-md font-bold text-center;
  min-width: 110px;
  transform: translate(-103%, -90%);
}
</style>
